import React, { useMemo, useRef } from 'react';
import { Skeleton } from '@yme/common/components/skeletons';
import { buildKey } from '@yme/common/index';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export function FilterResultSkeleton({ currentPerPageValue }) {
    const ref = useRef(null);
    const currentPerPageValueArr = Array(currentPerPageValue).fill('filterResultSkeletonItem');
    const { isMobileView } = useWindowSize();
    const containerWidth = ref.current?.clientWidth;
    const skeletonHeight = useMemo(() => {
        if (containerWidth) {
            if (isMobileView) {
                return containerWidth / 2 - 18;
            }
            return containerWidth / 3 - 18;
        }
        return 0;
    }, [containerWidth, isMobileView]);
    return (React.createElement(FlexWrapper, { isFullWidth: true, ref: ref },
        React.createElement(FlexWrapper, { isFullWidth: true, gap: "24px", flexWrap: "wrap" }, currentPerPageValueArr.map((item, index) => (React.createElement("div", { key: buildKey(item, index), style: {
                width: skeletonHeight,
            } },
            React.createElement(Skeleton, { skeletonProps: {
                    height: skeletonHeight,
                }, wrapperProps: {
                    mbM: 16,
                    mbS: 16,
                } }),
            React.createElement(Skeleton, { skeletonProps: {
                    height: isMobileView ? 24 : 28,
                }, wrapperProps: {
                    width: 200,
                    mbM: 8,
                    mbS: 8,
                } }),
            React.createElement(Skeleton, { skeletonProps: {
                    height: isMobileView ? 24 : 28,
                }, wrapperProps: {
                    width: 100,
                    mbM: 24,
                    mbS: 16,
                } })))))));
}
